/* eslint-disable react/no-array-index-key, no-loops/no-loops */

import React, { Fragment, useMemo } from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";

function _getLastString({ index, lastIndex, fullString }) {
	const lastString = fullString.slice(lastIndex, index);

	if (lastString && lastString.length) {
		return lastString;
	} else {
		return null;
	}
}

function _isEmpty(obj) {
	if (!obj) {
		return true;
	}

	if (obj.constructor === Object) {
		if (!Object.keys(obj).length) {
			return true;
		}
	} else if (!obj.length) {
		return true;
	}

	return false;
}

function _convertStrToArray(str, vars) {
	const strArray = [];

	// since the first key is "1", and arrays are zero-indexed,
	// prepend the replacements field with a dummy entry
	const replacements = Array.isArray(vars)
		? ["", ...vars]
		: vars;

	const finder = /\$(\d+|\w+)/g;
	const getNextItem = () => finder.exec(str);
	let currentItem = getNextItem();
	let lastIndex = 0;

	while (currentItem !== null) {
		// Get the text before the replacement.
		const lastString = _getLastString({
			lastIndex,
			fullString: str,
			index: currentItem.index,
		});

		if (lastString) {
			strArray.push(lastString);
		}

		// Get the replaced text.
		const replacement = replacements[currentItem[1]];
		strArray.push(replacement);

		// Update pointers.
		lastIndex = finder.lastIndex;
		currentItem = getNextItem();
	}

	// Get the text after the replacement.
	const lastString = _getLastString({
		lastIndex,
		index: str.length,
		fullString: str,
	});

	if (lastString) {
		strArray.push(lastString);
	}

	// eslint-disable-next-line react/no-array-index-key
	return strArray;
}

function _getTextFromChildren(children) {
	if (typeof (children) === "string") {
		return children;
	} else if (children && children.length) {
		return `${children[0]}`;
	} else {
		return "";
	}
}

const Strf = ({ children, vars, ...props }) => {
	const str = useMemo(() => {
		const string = _getTextFromChildren(children);

		// No vars to replace, do nothing.
		if (_isEmpty(vars)) {
			return string;
		}

		// Convert it an array, filling stuff in as needed.
		const strArr = _convertStrToArray(_str(string), vars);

		// Return a string to render.
		return strArr.length > 1
			? strArr.map((s, i) => <Fragment key={i}>{s}</Fragment>)
			: strArr[0];
	}, [children, vars]);

	// If there's any reason to make this a real element, do so.
	if (Object.keys(props).length) {
		return (
			<span {...props}>{str}</span>
		);
	}

	return (
		<Fragment>{str}</Fragment>
	);
};

Strf.propTypes = {
	children: PropTypes.node,
	vars: PropTypes.object,
};

Strf.defaultProps = {
	children: null,
	vars: {},
};

export default React.memo(Strf);



// WEBPACK FOOTER //
// ./src/shared/components/Strf.jsx